import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from "redux-saga";
import reducers from './reducers';
import rootSaga from "./sagas";
// avoid importing `composeWithDevTools` to prevent runtime dependency on its internal `compose`

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

export function configureStore(initialState: any) {

    const isBrowser = typeof window !== 'undefined';

    const composeEnhancers: any = (process.env.NODE_ENV === 'development' && isBrowser && typeof (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function')
        ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : compose;

    const enhancer = composeEnhancers(applyMiddleware(...middlewares));

    const store = createStore(
        reducers,
        initialState,
        enhancer,
    );
    sagaMiddleware.run(rootSaga);
    return store;
}

